import React from 'react';
import PropTypes from 'prop-types';
import { View, Text, StyleSheet } from 'react-native';

import Theme from '../../theme';

const PrivacyHeader = ({
    t,
    isPrivate,
    toggleSettingsModal
}) => (
        <View style={styles.container}>
            <View style={styles.headingContainer}>
                <Text
                    adjustsFontSizeToFit={true}
                    numberOfLines={1}
                    style={styles.header}>
                    {isPrivate
                        ?
                        t('privateHeaderMode')
                        :
                        t('publicHeaderMode')
                    }
                </Text>
                <Text style={styles.subHeading}>{isPrivate
                    ?
                    t('privateSubHeaderMode')
                    :
                    t('publicSubHeaderMode')
                }</Text>
            </View>
            <Text style={styles.changeText} onPress={toggleSettingsModal}>Change</Text>
        </View>
    );

PrivacyHeader.propTypes = {
    t: PropTypes.func.isRequired,
    isPrivate: PropTypes.bool.isRequired,
    toggleSettingsModal: PropTypes.func.isRequired,
};

const styles = StyleSheet.create({
    headingContainer: {
        flexDirection: 'column',
        paddingVertical: 10,
    },
    container: {
        flexDirection: 'row',
        paddingHorizontal: 15,
        justifyContent: 'space-between',
        backgroundColor: Theme.CHARCOAL,
        alignItems: 'center',
        borderColor:Theme.GREY_DARK_MEDIUM,
        borderWidth: 1,
        borderBottomWidth:0,
        borderLeftWidth:0,
        borderRightWidth:0,
    },
    header: {
        fontSize: 16,

        fontFamily:Theme.CustomBold,
        textAlign: 'left',
        color: Theme.GREY_LIGHT,
    },
    subHeading: {
        color: Theme.GREY_LIGHT,
        textAlign: 'left',
        fontSize: 14,

        fontFamily:Theme.Custom500,
    },
    changeText: {
        color: Theme.PRIMARY,
        fontSize: 14,

        fontFamily:Theme.Custom700,
    },
});

export default PrivacyHeader;
